<template>
  <div class="logo-wrap">
    <img src="/img/archestor-logo.svg" alt="Archestor Kft." class="logo" />
  </div>
</template>

<style scoped>
.logo-wrap {
  display: block;
  line-height: 0;
}

.logo {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>


